import React from 'react';

import Button from 'components/Button';

import styles from './Approved.scss';

const Approved = () => {
  const createAccountButtonProps = {
    className: styles.publishButton,
    primary: true,
    disabled: false,
    to: '/candidate/edit-preview',
  };

  return (
    <div className={styles.welcomeTop}>
      <div className={styles.approvedContainer}>
        <h2 className={styles.approvedHeader}>Congrats, you&apos;ve been approved!</h2>
        <div className={styles.approvedMessage}>You&apos;re ready to make it rain!</div>
        <Button {...createAccountButtonProps}>View Profile</Button>
      </div>
    </div>
  );
};

export default Approved;
